export const lobOptions = {
  telecom: "TEL",
  "power-gas": "POWGAS",
};

export const lobUrlMask = {
  TEL: "telecom",
  POWGAS: "power-gas",
};

export const lobUrlMaskRedux = {
  TEL: "telecom",
  POWGAS: "powerGas"
}

export const lobUrlToUserMask = {
  telecom: "Telecom",
  "power-gas": "P&G",
};

export const lobUserMask = {
  TEL: "Telecom",
  POWGAS: "P&G",
};

export const lobUrlToReducer = {
  telecom: "telecom",
  "power-gas": "powerGas",
};


export const integerToLOB = {
  1: "telecom",
  2: "power-gas",
};

export const lobToInteger = {
  "telecom": 1,
  "power-gas": 2,
}

export const integerToLobFormatted = {
  1: "Telecom",
  2: "Power & Gas",
}

export const lobUrlMaskInteger = {
  TEL: 1,
  POWGAS: 2,
}